import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  VStack,
  Box,
  Text,
  Button,
} from "@chakra-ui/react";
import QRCode from "qrcode.react";
import { observer } from "mobx-react-lite";
import { VotingViewModel } from "../VotingViewModel";

/**
 * Handoff tajnego głosu wymagającego portfela. Przeglądarka nie ma enklawy, więc nie może
 * zbudować suwerennej ceremonii ZK — kierujemy wyborcę do aplikacji (deep-link + QR dla desktopu),
 * zachowując webowy prover token-only dla tajnych głosowań BEZ wymogu portfela.
 */
export const WalletHandoff: React.FC<{ model: VotingViewModel }> = observer(({ model }) => {
  const url = model.handoffUrl;

  return (
    <Modal
      isOpen={model.showWalletHandoff}
      onClose={() => model.closeWalletHandoff()}
      isCentered
      size={{ base: "full", md: "lg" }}
      motionPreset="slideInBottom"
    >
      <ModalOverlay backdropFilter="blur(6px)" bg="rgba(20,8,40,0.6)" />
      <ModalContent borderRadius={{ base: "0", md: "24px" }} overflow="hidden" bg="white">
        {/* Nagłówek-ceremonia (gradient marki) */}
        <Box
          bgGradient="linear(150deg, #2E0069, #430098 55%, #6A1FC2)"
          px={{ base: "24px", md: "40px" }}
          py={{ base: "32px", md: "38px" }}
          color="white"
          position="relative"
        >
          <ModalCloseButton color="white" />
          <VStack spacing="16px" textAlign="center">
            <Box
              w="84px"
              h="84px"
              borderRadius="full"
              bg="rgba(255,255,255,0.16)"
              display="flex"
              alignItems="center"
              justifyContent="center"
              fontSize="38px"
            >
              🔒
            </Box>
            <Text fontSize={{ base: "22px", md: "26px" }} fontWeight="800" lineHeight="1.15">
              To głosowanie jest tajne i wymaga aplikacji
            </Text>
            <Text fontSize="15px" color="rgba(255,255,255,0.85)" maxW="440px">
              Ceremonia tajnego głosu powstaje w bezpiecznej enklawie Twojego telefonu — klucz i sekret
              <b> nigdy nie opuszczają urządzenia</b>. Przeglądarka nie ma enklawy, więc dokończ głos w
              aplikacji lubbezpośrednio.
            </Text>
          </VStack>
        </Box>

        {/* Akcje */}
        <VStack spacing="20px" px={{ base: "24px", md: "40px" }} py="32px" bg="white">
          <Button
            as="a"
            href={url}
            w="100%"
            h="52px"
            borderRadius="16px"
            bg="#430098"
            color="white"
            _hover={{ bg: "#360079" }}
            fontWeight="700"
            fontSize="16px"
          >
            Otwórz w aplikacji
          </Button>

          {/* QR dla desktopu */}
          <VStack spacing="8px">
            <Box p="14px" bg="white" border="1px solid #E6E1F2" borderRadius="18px">
              <QRCode value={url} size={150} fgColor="#2E0069" />
            </Box>
            <Text fontSize="13px" color="#6B7280" textAlign="center" maxW="320px">
              Na komputerze? Zeskanuj kod telefonem z zainstalowaną aplikacją.
            </Text>
          </VStack>

          <Text fontSize="12px" color="#9A93A8" textAlign="center">
            Nie masz aplikacji? Pobierz „lubbezpośrednio" na iOS lub Androida i wróć tym linkiem.
          </Text>
        </VStack>
      </ModalContent>
    </Modal>
  );
});
